import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2, Lock, User, Printer } from 'lucide-react';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      if (result.role === 'super_admin') {
        navigate('/companies');
      } else {
        navigate('/verify');
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 p-4">
      <div className="w-full max-w-md animate-in fade-in-0 zoom-in-95 duration-500">
        <div className="text-center mb-8">
          <div className="inline-block p-4 bg-blue-600 rounded-2xl shadow-xl shadow-blue-600/20 mb-4">
            <Printer className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-1" data-testid="app-title">MyPrinterManager.gr</h1>
          <p className="text-blue-300/70 text-sm">Σύστημα Διαχείρισης Εκτυπωτών</p>
        </div>

        <Card className="shadow-2xl border-0 bg-white/95 backdrop-blur">
          <CardHeader className="space-y-1 pb-4">
            <CardTitle className="text-xl text-center">Σύνδεση</CardTitle>
            <CardDescription className="text-center">
              Εισάγετε τα στοιχεία εταιρίας
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">Username</label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    data-testid="login-username"
                    type="text"
                    placeholder="Username εταιρίας"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="pl-10"
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">Password</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    data-testid="login-password"
                    type="password"
                    placeholder="Password εταιρίας"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-10"
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm animate-in fade-in-0 slide-in-from-top-2 duration-300" data-testid="login-error">
                  {error}
                </div>
              )}

              <Button
                data-testid="login-submit"
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 h-11 text-base"
                disabled={loading}
              >
                {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Σύνδεση...</> : 'Είσοδος'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-sm text-blue-300/50 mt-6">
          MyPrinterManager.gr
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
